/**
 *
 *
 * pc端 下拉题
 *
 * optionForm === 1
 *
 *   QA类型
 * derection === 0
 *
 *
 */
import React, { useState, useContext, useEffect } from "react";
import { Input, Table, Select } from "antd";
import { cloneDeep, isEmpty } from "lodash";
import ReactJson from "react-json-view";
import { InputWapper } from "@/utils/helper";
import AnswerValidityChren from "@/components/AnswerValidityChren";
import { contexData } from "@/store";
import { language } from "@/utils/language"; 
const descriptionRender = (text, record = {}) => {
  let html = text
    .replace(/<p><\/p>/g, "<br />")
    .replace(/\n\n/g, "<br />")
    .replace(/\s{2}/g, "&nbsp;&nbsp;");
  const div = (
    <div
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );

  if (record.moduleOption === 1) {
    return {
      children: (
        <div
          style={{
            background: "#c1c1c1",
            textAlign: "left",
            padding: "2px 40px",
          }}
        >
          {div}
        </div>
      ),
      props: {
        colSpan: 2,
      },
    };
  }
  return record.id ? (
    <AnswerValidityChren info={record}>{div}</AnswerValidityChren>
  ) : (
    div
  );
};

export default ({ info, answer, changeAnswer }) => {
  console.log(`src\\pages\\matrix\\MatrixSelect\\web\\QA.jsx`);

  const { dispatch } = useContext(contexData); //解构得到属性

  const { childs, preferences } = info;
  const {
    childPrefer: { firstColumnWidth },
  } = preferences;

  const [showInput, setShowInput] = useState({});

  const handleInputChange = (questionId, value) => {
    dispatch({ type: "highlight", data: { highlight: "" } });
    const answers = answer[info.id] || answer;
    const newAnswer = cloneDeep(answers);
    const obj = newAnswer[questionId];
    const [answerId] = Object.keys(obj);
    newAnswer[questionId][answerId] = value;
    changeAnswer(newAnswer);
  };

  const handleChange = (question, answerId) => {
    dispatch({ type: "highlight", data: { highlight: "" } });

    const { id: questionId } = question;
    const newAnswer = cloneDeep(answer);
    newAnswer[info.id] = newAnswer[info.id] || {};
    newAnswer[info.id][questionId] = { [answerId]: null };
    changeAnswer(newAnswer[info.id]);

    // 半开放框
    const option = question.options.find((o) => o.id === answerId);
    const { open } = option;
    setShowInput({ ...showInput, [questionId]: !!open });
  };

  useEffect(() => {
    if (isEmpty(answer)) return;
    if (!isEmpty(showInput)) return;

    try {
      const a = answer[info.id];
      const b = Object.keys(a);
      const obj = {};
      for (let i = 0; i < b.length; i++) {
        const c = Object.keys(a[b[i]])[0];
        obj[b[i]] = !!a[b[i]][c]?.text;
      }
      setShowInput(obj);
    } catch (error) {}
  }, [answer]);

  const optionRender = (text, record, index) => {
    const answers = answer[info.id] || answer;
    const value = Object.keys(answers[record.id] || {})[0];
    const inputValue =
      answers?.[record.id]?.[value]?.text || answers?.[record.id]?.[value];
    const select = (
      <Select
        style={{ width: "100%" }}
        onChange={(value) => handleChange(record, value)}
        value={value}
      >
        {record.options
          .filter((o) => !o.hide && !o.moduleOption)
          .map((o) => (
            <Select.Option key={o.id}>
              {descriptionRender(o.description)}
            </Select.Option>
          ))}
      </Select>
    );
    const input = (
      <InputWapper unit={record.unit}>
        <Input
         placeholder={language().input_placeholder}
          defaultValue={inputValue}
          onChange={(e) => handleInputChange(record.id, e.target.value)}
        />
      </InputWapper>
    );

    if (record.moduleOption === 1) {
      return {
        children: null,
        props: {
          align: "left",
          colSpan: 0,
        },
      };
    }

    return (
      <div style={{ margin: 4 }}>
        {select} {(showInput[record.id] || inputValue) && input}
      </div>
    );
  };

  const columns = [
    {
      dataIndex: "description",
      align: "center",
      width: `${firstColumnWidth}%`,
      render: descriptionRender,
    },
    {
      dataIndex: "answer",
      render: optionRender,
    },
  ];

  return (
    <>
      {document.domain === "localhost" && (
        <ReactJson src={answer} collapsed={false} />
      )}
      <Table
        rowKey="id"
        bordered
        pagination={false}
        showHeader={false}
        columns={columns}
        dataSource={childs.filter((o) => !o.hide && o.moduleOption !== 2)}
      />
    </>
  );
};
